import { BackendError } from "@exceptions";
import * as Sentry from "@sentry/react";
import { useEffect } from "react";
import { useRouteError } from "react-router-dom";

import NotFound from "./404";
import GenericError from "./generic";

export default function ErrorComponent() {
  const error = useRouteError() as Error;

  useEffect(() => {
    Sentry.captureException(error);
  }, [error]);

  if (error instanceof BackendError && error.statusCode === 404) {
    return <NotFound message={error.message} />;
  }

  if (import.meta.env.VITE_ENVIRONMENT === "local") {
    return <GenericError message={error.message} />;
  }

  return <GenericError />;
}
